import { Box, Button, Grid } from '@mui/material';
import { BoneTagEditor } from './BoneTagEditor';
import { AppContext } from '@/contexts/app.context';
import { BoneTag, MuscleTag } from '@/generated';
import { boneTagApi } from '@/generated/clients';
import { useContext, useState } from 'react';
import { CannotDeleteTagWarning, DeleteDialog } from '@/components/TagDeleteDialog';
import { isAdminUser } from '@/utils/user';
import { BoneInfoCard } from './BoneInfoCard';
import { EditBoneTagModal } from './EditBoneTagModal';

export const BoneTagsTab = () => {
  const { refreshBoneTagList, state } = useContext(AppContext);
  const [tagEditMode, setTagEditMode] = useState<boolean>(false);
  const [selectedTag, setSelectedTag] = useState<BoneTag>();
  const [cannotDelete, setCannotDelete] = useState<boolean>(false);
  const [tagToDelete, setTagToDelete] = useState<BoneTag | undefined>(undefined);
  const [showTagEditModal, setShowTagEditModal] = useState<boolean>(false);

  return (
    <>
      <CannotDeleteTagWarning open={cannotDelete} setOpen={setCannotDelete} />
      <DeleteDialog
        open={tagToDelete !== undefined}
        handleClose={async (deleted) => {
          if (deleted) {
            if (!tagToDelete) return;
            const deleteOk = await boneTagApi.boneTagDeleteRaw({ tagId: tagToDelete.id });
            if (deleteOk) {
              refreshBoneTagList();
            } else {
              setCannotDelete(true);
            }
          }
          setTagToDelete(undefined);
        }}
      />
      {selectedTag && (
        <EditBoneTagModal
          open={showTagEditModal}
          initialBoneTag={selectedTag}
          onClose={() => {
            setShowTagEditModal(false);
          }}
          boneTagUpdated={() => {
            refreshBoneTagList();
            setShowTagEditModal(false);
            setSelectedTag(undefined);
          }}
        />
      )}

      <Grid rowGap={3} columnGap={2} container>
        <Grid size={12}>
          {isAdminUser(state?.userProfile) && (
            <Box>
              <Button onClick={() => setTagEditMode(!tagEditMode)}>
                {tagEditMode ? 'Edit Mode (Click to enter selection mode)' : 'Selection Mode (Click to enter Edit mode)'}{' '}
              </Button>
            </Box>
          )}
        </Grid>
        <Grid size={9.5}>
          {state?.boneTagList && (
            <BoneTagEditor
              tagEditMode={tagEditMode}
              tagClicked={(tag) => {
                setSelectedTag(tag);
              }}
              tagCreated={async (tagName: string) => {
                await boneTagApi.boneTagCreate({ createBoneTag: { name: tagName } });
                refreshBoneTagList();
              }}
              tagRemoved={setTagToDelete}
              tagUpdated={async (tag: MuscleTag) => {
                await boneTagApi.boneTagUpdate({ boneTag: tag });
                refreshBoneTagList();
              }}
              boneTags={state?.boneTagList}
            />
          )}
        </Grid>
        <Grid size={12}>
          <BoneInfoCard
            onClick={() => {
              if (isAdminUser(state?.userProfile)) setShowTagEditModal(true);
            }}
            boneTag={selectedTag}
          />
        </Grid>
      </Grid>
    </>
  );
};
